import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import { setUpdatedData } from "helpers/data_setters"
import { customStyles } from "helpers/select-styles"
import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import swal from "sweetalert"

const AddConnectedMaster = ({
  show,
  setShow,
  client_type_options = [],
  clients_options = [],
  connection_id,
  settable_data,
  setconnection_id,
}) => {
  // Individual states for each field
  const [connection, setConnection] = useState([])
  const [connectionName, setConnectionName] = useState("")
  const [loading, setLoading] = useState(false)

  const [clientType, setClientType] = useState("")
  const [clientName, setClientName] = useState("")
  const [clientList, setClientList] = useState([])

  const [all_clients, setAllClients] = useState([])

  // reset values
  useEffect(() => {
    if (!show) {
      setConnection([])
      setConnectionName("")
      setconnection_id(null)
      setClientName("")
      setClientType("")
      setAllClients(
        clients_options.map(item => ({ value: item.id, label: item.clientName }))
      )
      setClientList(
        clients_options.map(item => ({
          ...item,
          clientType: item.clientType.clientType,
          isAdded: false,
        }))
      )
    }
  }, [show])

  // Getting Connection
  useEffect(() => {
    const getConnection = async () => {
      try {
        setLoading(true)
        const { data } = await axiosbaseurl.get(
          `/connected-client/${connection_id}`
        )
        if (data.success) {
          setConnectionName(data.data.connectionName)
          setConnection(
            data.connectionData
              ?.filter(c => c)
              ?.map(item => ({ value: item.id, label: item.clientName }))
          )
          // setAllClients
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }

    if (connection_id) getConnection()
  }, [connection_id])

  // set options
  useEffect(() => {
    setAllClients(
      clients_options.map(item => ({ value: item.id, label: item.clientName }))
    )
    setClientList(
      clients_options.map(item => ({
        ...item,
        clientType: item?.clientType?.clientType,
        isAdded: false,
      }))
    )
  }, [clients_options])

  // changing add status based on condition
  useEffect(() => {
    setClientList(prev =>
      prev.map(item => ({
        ...item,
        isAdded: connection.some(conn => conn.value === item.id),
      }))
    )
  }, [connection])


  // Searching Clients
  useEffect(() => {
    if ((clientType || clientName) && clients_options.length) {
      let filteredClients = clients_options.filter((client) => {
        return (
          ((clientName === "" ||
            client?.clientName?.toLowerCase()?.includes(clientName.toLowerCase()) ||
            client?.clientCode?.toLowerCase()?.includes(clientName.toLowerCase())))
          && (clientType === "" || client?.clientType?.clientType === clientType)
        );
      })?.map(item => ({
        ...item,
        clientType: item.clientType.clientType,
        isAdded: connection.some(conn => conn.value === item.id),
      }))
      setClientList(filteredClients);
    } else {

      setClientList(
        clients_options?.map(item => ({
          ...item,
          clientType: item.clientType.clientType,
          isAdded: connection.some(conn => conn.value === item.id),
        }))
      )

    }
  }, [clientType, clientName, clients_options]);

  //  ============


  // Adding before save
  const handleAddConnection = (client_id, type, index) => {
    const clients = [...clientList]
    if (type === "add") {
      clients[index].isAdded = true
      setClientList(clients)
      setConnection(prev => [
        ...prev,
        { value: clients[index].id, label: clients[index].clientName },
      ])
    }

    if (type === "remove") {
      clients[index].isAdded = false
      setConnection(prev => prev.filter(item => item.value !== client_id))
    }
  }

  // save to DB
  const handleSaveConnection = async e => {
    e.preventDefault()

    try {
      setLoading(true)
      const post_data = {
        connectionName,
        newConnectionsId: connection.map(item => item.value),
      }

      let response

      if (connection_id) {
        response = await axiosbaseurl.put(
          `/connected-client/${connection_id}`,
          post_data
        )
        settable_data(prev => setUpdatedData(prev, response.data.data, "edit"))
      } else {
        response = await axiosbaseurl.post("/connected-client", post_data)
        settable_data(prev => setUpdatedData(prev, response.data.data, "add"))
      }

      if (response.data.success) {
        swal("", response.data.message, "success")
        setShow(false)
      }
    } catch (error) {
      console.log(error)
      const msg =
        error.response.data.message || error.message || "Something went Wrong"
      swal(
        "",
        msg,
        msg.includes("No changes were made !") ||
          msg.includes("Please select clients to create connection") ||
          msg.includes("Please select clients to maintain connection")
          ? "warning"
          : "error"
      )
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      size="lg"
      isOpen={show}
      toggle={() => setShow(!show)}
      centered={true}
    >
      <form onSubmit={handleSaveConnection}>
        <div className="modal-content">
          <ModalHeader className="w-100 bg-primary">
            <div className="d-flex align-items-center justify-content-between w-100 ">
              <h4 className="mb-0" style={{ color: "#d9ebed" }}>
                {" "}
                {connection_id ? "Edit" : "Add"} Connection{" "}
              </h4>
              <div>
                <LoadingButton loading={loading} btn="light" />
                <button
                  type="button"
                  className="btn btn-danger ms-3"
                  onClick={() => setShow(!show)}
                >
                  <i className="fa fa-times me-2"></i> Close
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody className="px-3">
            <div className="row">
              <div className="col-12">
                <div className="mb-3">
                  <label>
                    New Connection <span className="text-danger">*</span>
                  </label>

                  <Select
                    value={connection}
                    onChange={e => setConnection(e)}
                    options={all_clients}
                    styles={customStyles}
                    isMulti
                  />
                </div>

                <div className="mb-4">
                  <label>
                    Connection Name <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    value={connectionName}
                    placeholder="Enter Connection Name"
                    onChange={e => setConnectionName(e.target.value)}
                    className="form-control input-field"
                    required
                  />
                </div>
              </div>
              <div className=" border-top border-secondary pt-4">
                <h5>Search Client</h5>
              </div>
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  value={clientName}
                  placeholder="By client name OR client code.."
                  onChange={e => setClientName(e.target.value)}
                  className="form-control input-field"
                />
              </div>
              <div className="col-md-4 mb-3">
                <select
                  value={clientType}
                  onChange={e => setClientType(e.target.value)}
                  className="form-select input-field"
                >
                  <option value="">Select Client Type</option>
                  {client_type_options?.map(option => (
                    <option key={option.id} value={option.clientType}>
                      {option.clientType}
                    </option>
                  ))}
                  {/* Add options dynamically */}
                </select>
              </div>

              <div className="col-12">
                <div className="table-responsive table_header_fixed">
                  <table className="table">
                    <thead className="table-primary">
                      <tr>
                        <th>Client Name</th>
                        <th>Client Code</th>
                        <th>Client Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {clientList.map((client, i) => {
                        return (
                          <tr key={i}>
                            <td>{client.clientName}</td>
                            <td>{client.clientCode}</td>
                            <td>{client.clientType}</td>
                            <td>
                              {client.isAdded ? (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleAddConnection(client.id, "remove", i)
                                  }
                                  className={`btn btn-sm btn-danger`}
                                >
                                  <i className="fa fa-times me-1"></i>
                                  Remove it{" "}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() =>
                                    handleAddConnection(client.id, "add", i)
                                  }
                                  className={`btn btn-sm btn-light`}
                                >
                                  <i className="fa fa-plus me-1"></i>
                                  Add it{" "}
                                </button>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                      {!clientList.length && (
                        <tr>
                          <th colSpan={4} className="text-danger text-center">
                            {" "}
                            Not Found!{" "}
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ModalBody>
        </div>
      </form>
    </Modal>
  )
}

export default AddConnectedMaster
